ixModuleRouting("impactx.inputsettings", {
    "/inputsettingslist/:comId": {
        template: "<ixa-input-settings-list></ixa-input-settings-list>",
        process: "EditInputSettings",
        workspace: "admin",
    },
    "/inputsettings/:id/:comId": {
        template: "<ixa-input-settings></ixa-input-settings>",
        process: "EditInputSettings",
        workspace: "admin",
    }
});